import AssistantCopilotThreadsAPI from 'dashboard/api/assistant/copilotThreads';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'AssistantCopilotThread',
  API: AssistantCopilotThreadsAPI,
});
